import { render, staticRenderFns } from "./RelationInfo.vue?vue&type=template&id=466addb7&scoped=true"
import script from "./RelationInfo.vue?vue&type=script&lang=js"
export * from "./RelationInfo.vue?vue&type=script&lang=js"
import style0 from "./RelationInfo.vue?vue&type=style&index=0&id=466addb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466addb7",
  null
  
)

export default component.exports